/**
 * Collection Scroll Position Restoration (AJAX Pagination Support)
 * Saves scroll position and loaded pages when navigating to product page
 * Restores everything when returning via back button
 */

(function() {
  'use strict';

  const STORAGE_KEY = 'collection_scroll_position';
  const STORAGE_URL_KEY = 'collection_scroll_url';
  const STORAGE_LOADED_PAGES_KEY = 'collection_loaded_pages';

  // Check if we're on a collection page
  function isCollectionPage() {
    return document.body.classList.contains('template-collection') ||
           window.location.pathname.includes('/collections/');
  }

  // Get all "Load More" button URLs that have been clicked
  function getLoadedPageUrls() {
    const loadedUrls = [];

    // Look for pagination data in the page
    const paginationButtons = document.querySelectorAll('[id^="btn-pagination-"] a[data-url], [id^="btn-pagination-"] button[data-url]');

    if (paginationButtons.length > 0) {
      // If there are pagination buttons, track which page we're on
      const currentPageMatch = window.location.search.match(/page=(\d+)/);
      const currentPage = currentPageMatch ? parseInt(currentPageMatch[1]) : 1;

      // For AJAX infinite scroll, we need to track loaded content
      const itemsGrid = document.getElementById('items-grid');
      if (itemsGrid) {
        // Count how many products are loaded
        const productCount = itemsGrid.querySelectorAll('.grid-item').length;
        loadedUrls.push({
          productCount: productCount,
          currentPage: currentPage
        });
      }
    }

    return loadedUrls;
  }

  // Save scroll position and loaded state before navigating away
  function saveScrollPosition() {
    if (isCollectionPage()) {
      const scrollY = window.scrollY || window.pageYOffset;
      const currentUrl = window.location.href;
      const loadedPages = getLoadedPageUrls();

      sessionStorage.setItem(STORAGE_KEY, scrollY.toString());
      sessionStorage.setItem(STORAGE_URL_KEY, currentUrl);
      sessionStorage.setItem(STORAGE_LOADED_PAGES_KEY, JSON.stringify(loadedPages));

      console.log('Saved scroll position:', scrollY, 'for URL:', currentUrl);
      console.log('Saved loaded pages:', loadedPages);
    }
  }

  // Auto-load pagination pages to restore state
  function reloadPaginationPages(callback) {
    const savedPages = sessionStorage.getItem(STORAGE_LOADED_PAGES_KEY);

    if (!savedPages) {
      callback();
      return;
    }

    try {
      const loadedData = JSON.parse(savedPages);

      if (!loadedData || loadedData.length === 0) {
        callback();
        return;
      }

      const targetProductCount = loadedData[0].productCount;

      if (!targetProductCount) {
        callback();
        return;
      }

      // Function to check if we've loaded enough products
      function checkAndLoadMore() {
        const itemsGrid = document.getElementById('items-grid');
        if (!itemsGrid) {
          callback();
          return;
        }

        const currentProductCount = itemsGrid.querySelectorAll('.grid-item').length;

        console.log('Current products:', currentProductCount, 'Target:', targetProductCount);

        if (currentProductCount >= targetProductCount) {
          console.log('All products loaded, restoring scroll position');
          callback();
          return;
        }

        // Find the "Load More" button
        const loadMoreButton = document.querySelector('[id^="btn-pagination-"] a, [id^="btn-pagination-"] button');

        if (!loadMoreButton) {
          console.log('No load more button found, restoring scroll position');
          callback();
          return;
        }

        // Check if Alpine.js pagination component exists
        const paginationEl = loadMoreButton.closest('[x-data]');
        if (paginationEl && window.Alpine) {
          // Click the button and wait for loading to complete
          console.log('Clicking load more button...');
          loadMoreButton.click();

          // Wait for the loading to complete
          setTimeout(function() {
            checkAndLoadMore();
          }, 1000); // Wait 1 second before checking again
        } else {
          callback();
        }
      }

      // Start loading more products
      checkAndLoadMore();

    } catch (e) {
      console.error('Error reloading pagination:', e);
      callback();
    }
  }

  // Restore scroll position when returning to collection
  function restoreScrollPosition() {
    if (isCollectionPage()) {
      const savedUrl = sessionStorage.getItem(STORAGE_URL_KEY);
      const currentUrl = window.location.href;

      // Only restore if we're returning to the same collection page
      if (savedUrl === currentUrl) {
        const savedPosition = sessionStorage.getItem(STORAGE_KEY);

        if (savedPosition) {
          const scrollY = parseInt(savedPosition, 10);

          console.log('Will restore scroll position:', scrollY);

          // First, reload any AJAX-loaded pages
          reloadPaginationPages(function() {
            // Then restore scroll position
            console.log('Restoring scroll position:', scrollY);

            // Use requestAnimationFrame for smoother scrolling
            requestAnimationFrame(function() {
              window.scrollTo(0, scrollY);

              // Double-check after a short delay (for lazy-loaded images)
              setTimeout(function() {
                window.scrollTo(0, scrollY);
              }, 100);
            });
          });

          // Clear the saved data after restoring
          sessionStorage.removeItem(STORAGE_KEY);
          sessionStorage.removeItem(STORAGE_URL_KEY);
          sessionStorage.removeItem(STORAGE_LOADED_PAGES_KEY);
        }
      }
    }
  }

  // Save scroll position when clicking on product links
  function attachProductLinkListeners() {
    // Listen for clicks on product links
    document.addEventListener('click', function(e) {
      // Find if the click is on or inside a product link
      const productLink = e.target.closest('a[href*="/products/"]');

      if (productLink && isCollectionPage()) {
        saveScrollPosition();
      }
    }, true); // Use capture phase to catch the event early
  }

  // Handle browser back/forward navigation
  window.addEventListener('pageshow', function(event) {
    // Check if page is loaded from cache (back button)
    if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
      restoreScrollPosition();
    }
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      restoreScrollPosition();
      attachProductLinkListeners();
    });
  } else {
    restoreScrollPosition();
    attachProductLinkListeners();
  }

  // Also save position before page unload (backup)
  window.addEventListener('beforeunload', function() {
    if (isCollectionPage()) {
      saveScrollPosition();
    }
  });

})();
